<template>
  <div>
    <el-input type="text" @change="change" :disabled="disabled" v-model="displayValue" :clearable="clearable" @blur="isInputActive = false" @focus="isInputActive = true" :maxlength="14" class="currency-input"/>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: 0
    },
    disabled: {
      default: false
    },
    clearable: {
      default: false
    },
    change: {
      type: Function,
      default: () => 1
    }
  },
  data: function () {
    return {
      isInputActive: false
    }
  },
  computed: {
    displayValue: {
      get: function () {
        if (this.isInputActive && this.value !== null) {
          // Cursor is inside the input field. unformat display value for user
          return this.value.toString()
        } else {
          // User is not modifying now. Format display value for user interface
          if (this.value === null || this.value === '') {
            return '$'
          }
          if (this.value.toString().substr(0, 1) === '$') {
            return this.value.toString().substr(1, this.value.length)
          }
          return '$ ' + parseFloat(this.value).toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
        }
      },
      set: function (modifiedValue) {
        // Recalculate value after ignoring "$" and "," in user input
        // eslint-disable-next-line
        let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ''))
        // Ensure that it is not NaN
        if (isNaN(newValue)) {
          if (this.clearable === false || this.clearable === 'false') {
            newValue = 0
          } else {
            newValue = null
          }
        }
        // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
        // $emit the event so that parent component gets it
        this.$emit('input', newValue)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input {
  max-width: 150px;
}
</style>
